export class BaseResponse {
  status?: string;
  codigoRespuesta?: string;
  errorMessage?: string;
  mensaje?: string;
  totalRegistros?: number;
  totalPaginas?: number;
  data?: any;
}
